import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Navbar from "components/layout/Navbar/Navbar";
import LoadingScreen from "components/ui/LoadingScreen/LoadingScreen";

import "react-toastify/dist/ReactToastify.css";
import "./AppLayout.css";

/**
 * The shell every routed page renders inside.
 *
 * Suspense sits here rather than around the whole router, so a lazy page swap
 * only blanks the content area instead of unmounting the navigation with it.
 */
export default function AppLayout() {
  return (
    <>
      <Navbar />
      <main className="page">
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </main>
      <ToastContainer position="top-right" autoClose={2200} theme="colored" />
    </>
  );
}
